<template>
<div
  class="input-group w-auto"
>
  <div
    class="input-group-prepend"
  >
    <div
      class="input-group-text"
    >
      <ItpIcon
        icon="material-symbols:numbers-rounded"
      >
      </ItpIcon>
    </div>
  </div>
  <ItpFormSelect
    name="numbering"
    v-model="selectedID"
    :options="options"
    valueField="id"
    textField="description"
    :readonly="options.length == 1"
    @input="evh_5962862420439144_input($event, {})"
  >
  </ItpFormSelect>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceNumberingSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    required: true,
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    required: true,
    type: Array,
  })
  options!: array;

  @Watch('options')
  onOptions(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("options")
  }

  selectedID!: any;

  async $$load_selectedID() {
    return this.value.id
  }

  ux!: any;
  dataMembers = ['selectedID', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedID: null,
        ux: null,
      },
    }
  }

  async act_5962862420439144_script_7604_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_7604, alias=undefined
    console.log($event, this.selectedID)
  }

  async act_5962862420439144_script_7604_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_7604, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_7604_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_input_7603_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_5962862420439144_input_7603, alias=undefined
    return this.value.id !== this.selectedID
  }

  async act_5962862420439144_request_7606_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_5962862420439144_request_7606, alias=saveSelection
    return {
      operation: "update_invoice",
      data: { id: this.invoice.id, etag: this.invoice.etag, numbering_id: this.selectedID },
    }
  }

  async evh_5962862420439144_input_7605_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_5962862420439144_input_7605, alias=undefined
    return this.value.id !== this.selectedID
  }

  async evh_5962862420439144_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_script_7604: actions.ScriptAction;
    evh_5962862420439144_input_7603: actions.EventHandlerImpl;
    act_5962862420439144_request_7606: actions.RequestAction;
    evh_5962862420439144_input_7605: actions.EventHandlerImpl;
    evh_5962862420439144_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_script_7604 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_7604_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_input_7603 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_7604,
        event: "input",
        when: this.evh_5962862420439144_input_7603_getWhen,
        displayName: "script",
      }
    );
    const act_5962862420439144_request_7606 = new actions.RequestAction(
      {
        actionArgs: this.act_5962862420439144_request_7606_getActionArgs,
        displayName: "saveSelection",
        events: [],
      }
    );
    const evh_5962862420439144_input_7605 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_request_7606,
        event: "input",
        when: this.evh_5962862420439144_input_7605_getWhen,
        displayName: "saveSelection",
      }
    );
    const evh_5962862420439144_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_input_7603, evh_5962862420439144_input_7605],
      }
    );
    return {
      act_5962862420439144_script_7604,
      evh_5962862420439144_input_7603,
      act_5962862420439144_request_7606,
      evh_5962862420439144_input_7605,
      evh_5962862420439144_input,
      saveSelection: act_5962862420439144_request_7606,
    }
  }
}

Vue.component("UcInvoiceNumberingSelector", UcInvoiceNumberingSelector);

</script>